function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2a423c;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M315.29,396l10.18,53.15H316l-2.2-11.56H304l-2.32,11.56h-5.35L306.37,396ZM305,433.42h8L308.94,409Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M357.44,407a11.38,11.38,0,0,0-1.41-3.14,11.06,11.06,0,0,0-2.07-2.36,9.07,9.07,0,0,0-2.45-1.47,6.75,6.75,0,0,0-2.48-.51,5.81,5.81,0,0,0-4.15,1.76,13.69,13.69,0,0,0-3.05,4.84,33.49,33.49,0,0,0-1.85,7.29,61.58,61.58,0,0,0-.63,9.11,78,78,0,0,0,.53,9.48,37,37,0,0,0,1.57,7.29,14.17,14.17,0,0,0,2.48,4.68,4.34,4.34,0,0,0,3.33,1.67,4.88,4.88,0,0,0,2.65-.79,7.08,7.08,0,0,0,2.19-2.23,11.85,11.85,0,0,0,1.48-3.45,17.94,17.94,0,0,0,.53-4.53,8.07,8.07,0,0,0-.28-2.35,3.29,3.29,0,0,0-.85-1.45,3,3,0,0,0-1.38-.72,12.1,12.1,0,0,0-2-.25l.38-2.64h11.75v11.43a17.9,17.9,0,0,0,.5,4.24,17.36,17.36,0,0,0,1.57,4.06l-4.4,2.38a17.14,17.14,0,0,1-1.88-3.83,18.23,18.23,0,0,1-5.34,3.36,17.59,17.59,0,0,1-7.1,1.42,15.54,15.54,0,0,1-7-1.45,11.23,11.23,0,0,1-4.74-4.77,27.22,27.22,0,0,1-2.73-8.74A84.29,84.29,0,0,1,329.8,422a53.12,53.12,0,0,1,1.1-11.34,23.26,23.26,0,0,1,3.55-8.48,16.17,16.17,0,0,1,6.28-5.35A21.3,21.3,0,0,1,350,395a11.73,11.73,0,0,1,8.11,2.8,16.5,16.5,0,0,1,4.64,7.82Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M388,396l10.18,53.15h-9.43l-2.19-11.56h-9.86l-2.33,11.56H369L379.05,396Zm-10.3,37.44h8L381.63,409Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M413.54,396v53.15h-9.36V396Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M430,396l15,29.46V396h5.46v54.28h-2.32l-20.61-39.71v38.58H422V396Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M477.18,405.9a11.52,11.52,0,0,0-2.92-4.49,5,5,0,0,0-3.11-1.41,5.68,5.68,0,0,0-2.73.66,6.54,6.54,0,0,0-2.08,1.76,8.79,8.79,0,0,0-.56,9.8,21.42,21.42,0,0,0,3.11,4q1.89,1.9,4,3.86a39.45,39.45,0,0,1,4,4.24,21.78,21.78,0,0,1,3.11,5.06,15.27,15.27,0,0,1,1.23,6.28,15.7,15.7,0,0,1-1.2,6.37,13.28,13.28,0,0,1-3.2,4.59,12.7,12.7,0,0,1-4.78,2.76,18.46,18.46,0,0,1-5.84.92q-5,0-7.69-2.33a15.82,15.82,0,0,1-4.37-6.85L459,438c.33.93.7,1.83,1.1,2.71a10,10,0,0,0,1.41,2.32,6.19,6.19,0,0,0,1.95,1.61,5.93,5.93,0,0,0,2.76.59,4.67,4.67,0,0,0,4.4-2.51,13.85,13.85,0,0,0,1.38-6.66,9.66,9.66,0,0,0-1.13-4.62,21.38,21.38,0,0,0-2.86-4.05c-1.15-1.3-2.39-2.6-3.7-3.89a48.73,48.73,0,0,1-3.71-4.06,20.59,20.59,0,0,1-2.86-4.55,13,13,0,0,1-1.13-5.47,17.47,17.47,0,0,1,.85-5.49,13,13,0,0,1,2.57-4.59,12.7,12.7,0,0,1,4.34-3.18,14.86,14.86,0,0,1,6.19-1.19,12,12,0,0,1,6.69,1.76,11.45,11.45,0,0,1,4.18,5.72Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M512.74,396v8.61H512c-.84-2.94-2.12-4.4-3.83-4.4h-4.4v48.94h-9.42V400.19h-5q-2.32,0-3.52,4.33h-.69V396Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M323.39,463.2v8.61h-.75q-1.26-4.4-3.83-4.4h-4.4v48.94H305V467.41h-5c-1.55,0-2.72,1.45-3.52,4.33h-.69V463.2Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M337,463.2V487h12.5V463.2h9.3v53.15h-9.3V491.16H337v25.19h-9.36V463.2Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M394.19,463.2v4.21H375.53v20.23h10.74v4.15H375.53v20.48h18.66v4.08h-28V463.2Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M307.44,531.82v25h13.11v-25h9.76v55.76h-9.76V561.15H307.44v26.43h-9.82V531.82Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M360.5,530.76q8.82,0,13.18,7.09T378,558.38a65.64,65.64,0,0,1-1.25,13.68,24.58,24.58,0,0,1-4,9.46,16.42,16.42,0,0,1-7.05,5.47,27.54,27.54,0,0,1-10.45,1.78,17,17,0,0,1-7.71-1.62,12.91,12.91,0,0,1-5.34-5.17,27.24,27.24,0,0,1-3.1-9.2,80.4,80.4,0,0,1-1-13.67,55.21,55.21,0,0,1,1.19-12.06,23.28,23.28,0,0,1,3.86-8.9,16.86,16.86,0,0,1,6.92-5.51A25.64,25.64,0,0,1,360.5,530.76Zm-2.38,5a5.78,5.78,0,0,0-4.18,1.78,14.08,14.08,0,0,0-3.07,4.94A34.86,34.86,0,0,0,349,550a65,65,0,0,0-.66,9.65,67.47,67.47,0,0,0,.63,9.46,37.23,37.23,0,0,0,1.85,7.75,16.67,16.67,0,0,0,2.93,5.24A5.1,5.1,0,0,0,357.6,584a6,6,0,0,0,4.25-1.78A13.76,13.76,0,0,0,365,577.3a34.31,34.31,0,0,0,2-7.51,61.25,61.25,0,0,0,.69-9.56,68.4,68.4,0,0,0-.66-9.86,36.18,36.18,0,0,0-1.91-7.77,14.68,14.68,0,0,0-3-5.08A5.45,5.45,0,0,0,358.12,535.71Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M396.75,531.82v44.36a6.54,6.54,0,0,0,.69,3,7.77,7.77,0,0,0,1.84,2.41A9.52,9.52,0,0,0,402,583.2a8.38,8.38,0,0,0,3.17.63A5.4,5.4,0,0,0,409.5,582a7.36,7.36,0,0,0,1.55-4.88V531.82h5.74v43.3a14.75,14.75,0,0,1-1.55,7.32,11.07,11.07,0,0,1-4,4.12,14.2,14.2,0,0,1-5.4,1.81,44.09,44.09,0,0,1-5.9.4q-13.05,0-13.05-11.67V531.82Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M446.65,542.23a12.16,12.16,0,0,0-3.07-4.71,5.18,5.18,0,0,0-3.26-1.48,6,6,0,0,0-2.87.69,6.91,6.91,0,0,0-2.18,1.84,9.28,9.28,0,0,0-.59,10.29,22.73,22.73,0,0,0,3.26,4.15q2,2,4.22,4a43.45,43.45,0,0,1,4.22,4.45,22.68,22.68,0,0,1,3.26,5.31,16,16,0,0,1,1.29,6.59,16.67,16.67,0,0,1-1.25,6.69,14.34,14.34,0,0,1-3.36,4.81,13.58,13.58,0,0,1-5,2.9,19.43,19.43,0,0,1-6.13,1c-3.47,0-6.17-.82-8.08-2.44a16.58,16.58,0,0,1-4.58-7.19l5.08-3.23c.35,1,.73,1.92,1.15,2.84a11.48,11.48,0,0,0,1.48,2.44,6.53,6.53,0,0,0,2,1.68,6.1,6.1,0,0,0,2.9.62,4.89,4.89,0,0,0,4.61-2.63,14.47,14.47,0,0,0,1.45-7,9.94,9.94,0,0,0-1.19-4.84,22.33,22.33,0,0,0-3-4.25c-1.22-1.37-2.51-2.73-3.89-4.09a53.48,53.48,0,0,1-3.89-4.25,22.06,22.06,0,0,1-3-4.78,13.55,13.55,0,0,1-1.19-5.74,18.56,18.56,0,0,1,.89-5.76,13.49,13.49,0,0,1,2.71-4.81,13.06,13.06,0,0,1,4.54-3.33,15.43,15.43,0,0,1,6.49-1.26,12.49,12.49,0,0,1,7,1.85,12,12,0,0,1,4.39,6Z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M488.17,531.82v4.41H468.6v21.23h11.27v4.35H468.6V583.3h19.57v4.28h-29.4V531.82Z"
});

var _ref18 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "296.44 696.14 600 696.14 600 211.31 296.44 46.11 296.44 93.15 561.6 235.89 561.6 658.08 296.44 658.08 296.44 696.14"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M214.9,176v4.41H195.33v22H209.1v4.42H195.33v25h-9.76V176Z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M239.16,174.92q8.84,0,13.18,7.09t4.35,20.53a65.64,65.64,0,0,1-1.25,13.68,24.32,24.32,0,0,1-4,9.45,16.31,16.31,0,0,1-7,5.48A27.54,27.54,0,0,1,234,232.93a17,17,0,0,1-7.71-1.62,13,13,0,0,1-5.34-5.17,27.32,27.32,0,0,1-3.1-9.2,80.44,80.44,0,0,1-1-13.68A55.34,55.34,0,0,1,218,191.2a23.46,23.46,0,0,1,3.86-8.89,16.85,16.85,0,0,1,6.92-5.51A25.64,25.64,0,0,1,239.16,174.92Zm-2.38,4.94a5.79,5.79,0,0,0-4.18,1.79,13.92,13.92,0,0,0-3.06,4.94,34.26,34.26,0,0,0-1.92,7.55,65,65,0,0,0-.66,9.65,67.47,67.47,0,0,0,.63,9.46,37.23,37.23,0,0,0,1.85,7.75,16.67,16.67,0,0,0,2.93,5.24,5.1,5.1,0,0,0,3.89,1.94,6,6,0,0,0,4.25-1.78,13.94,13.94,0,0,0,3.16-4.94,34.25,34.25,0,0,0,2-7.52,61.12,61.12,0,0,0,.69-9.55,68.4,68.4,0,0,0-.66-9.86,36.43,36.43,0,0,0-1.91-7.78,14.57,14.57,0,0,0-3-5.07A5.44,5.44,0,0,0,236.78,179.86Z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M282.33,176a8.92,8.92,0,0,1,5,1.41A11.87,11.87,0,0,1,290.9,181a16.83,16.83,0,0,1,2.08,5,22.47,22.47,0,0,1,.69,5.47,14.59,14.59,0,0,1-1.78,7.05,10.78,10.78,0,0,1-5.07,4.81,8,8,0,0,1,5,4.09,15,15,0,0,1,1.71,7.25v10c0,2.63.9,4.24,2.7,4.81v2.77a12.82,12.82,0,0,1-2.44.2,16.42,16.42,0,0,1-4-.47,9.06,9.06,0,0,1-3.16-1.41,6.91,6.91,0,0,1-2.08-2.41,7.52,7.52,0,0,1-.76-3.49V212a6.09,6.09,0,0,0-.39-2.11,8.14,8.14,0,0,0-1-1.91,5.75,5.75,0,0,0-1.45-1.42,2.85,2.85,0,0,0-1.61-.56h-5.8v25.71h-9.82V176Zm-8.83,25.77h6.59a2.26,2.26,0,0,0,1.68-.82,7.05,7.05,0,0,0,1.29-2.15,14.74,14.74,0,0,0,.82-2.9,16.91,16.91,0,0,0,.3-3.16,19.33,19.33,0,0,0-.6-5,12.78,12.78,0,0,0-1.68-3.89,7.7,7.7,0,0,0-2.67-2.54,7,7,0,0,0-3.49-.89H273.5Z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M220.64,247.23v9h-.79q-1.32-4.6-4-4.61h-4.61V303h-9.89V251.65h-5.28q-2.43,0-3.68,4.54h-.73v-9Z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M234.94,247.23v25h13.12v-25h9.76V303h-9.76V276.56H234.94V303h-9.82V247.23Z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M296.24,247.23v4.42H276.67v21.22h11.27v4.35H276.67v21.49h19.57V303h-29.4V247.23Z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M112.87,318.48v25H126v-25h9.76v55.76H126V347.81H112.87v26.43h-9.82V318.48Z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M167.25,317.42q8.83,0,13.18,7.09T184.78,345a65.51,65.51,0,0,1-1.25,13.68,24.36,24.36,0,0,1-4,9.46,16.36,16.36,0,0,1-7,5.47A27.34,27.34,0,0,1,162,375.43a17,17,0,0,1-7.71-1.62,12.85,12.85,0,0,1-5.34-5.17,27.24,27.24,0,0,1-3.1-9.2,80.4,80.4,0,0,1-1-13.67,55.21,55.21,0,0,1,1.19-12.06,23.35,23.35,0,0,1,3.86-8.9,16.86,16.86,0,0,1,6.92-5.51A25.64,25.64,0,0,1,167.25,317.42Zm-2.38,4.95a5.78,5.78,0,0,0-4.18,1.78,13.92,13.92,0,0,0-3.06,4.94,34.41,34.41,0,0,0-1.92,7.55,65,65,0,0,0-.66,9.65,67.61,67.61,0,0,0,.63,9.47,37.28,37.28,0,0,0,1.85,7.74,16.56,16.56,0,0,0,2.93,5.24,5.1,5.1,0,0,0,3.89,1.94,6,6,0,0,0,4.25-1.78,13.76,13.76,0,0,0,3.16-4.94,34.16,34.16,0,0,0,2-7.51,61.25,61.25,0,0,0,.69-9.56,68.5,68.5,0,0,0-.66-9.86,36.18,36.18,0,0,0-1.91-7.77,14.52,14.52,0,0,0-3-5.08A5.45,5.45,0,0,0,164.87,322.37Z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M203.5,318.48v44.36a6.58,6.58,0,0,0,.69,3,8,8,0,0,0,1.85,2.4,9.52,9.52,0,0,0,2.67,1.65,8.14,8.14,0,0,0,3.16.63,5.43,5.43,0,0,0,4.39-1.85,7.36,7.36,0,0,0,1.54-4.88V318.48h5.74v43.31A14.73,14.73,0,0,1,222,369.1a10.89,10.89,0,0,1-4,4.12,14.25,14.25,0,0,1-5.41,1.81,44.09,44.09,0,0,1-5.9.4q-13,0-13-11.67V318.48Z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M253.4,328.89a12.16,12.16,0,0,0-3.07-4.71,5.18,5.18,0,0,0-3.26-1.48,6,6,0,0,0-2.87.69,6.92,6.92,0,0,0-2.18,1.85,9,9,0,0,0-1.38,2.6,9.28,9.28,0,0,0,.79,7.68,22.73,22.73,0,0,0,3.26,4.15q2,2,4.22,4.05a43.45,43.45,0,0,1,4.22,4.45,22.89,22.89,0,0,1,3.26,5.31,16.08,16.08,0,0,1,1.29,6.59,16.67,16.67,0,0,1-1.25,6.69,14.24,14.24,0,0,1-3.36,4.81,13.45,13.45,0,0,1-5,2.9,19.43,19.43,0,0,1-6.13,1c-3.47,0-6.17-.82-8.08-2.44a16.55,16.55,0,0,1-4.58-7.18l5.08-3.24c.35,1,.73,1.92,1.15,2.84a11.24,11.24,0,0,0,1.48,2.44,6.53,6.53,0,0,0,2.05,1.68,6.1,6.1,0,0,0,2.9.63,4.88,4.88,0,0,0,4.61-2.64,14.47,14.47,0,0,0,1.45-7,10,10,0,0,0-1.19-4.84,22.64,22.64,0,0,0-3-4.25q-1.81-2.06-3.89-4.09A53.48,53.48,0,0,1,236,343.1a22.06,22.06,0,0,1-3-4.78,13.5,13.5,0,0,1-1.19-5.73,18.63,18.63,0,0,1,.89-5.77,13.49,13.49,0,0,1,2.71-4.81,13.19,13.19,0,0,1,4.54-3.33,15.45,15.45,0,0,1,6.5-1.26,12.46,12.46,0,0,1,7,1.85,12,12,0,0,1,4.39,6Z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M296.24,318.48v4.42H276.67v21.22h11.27v4.35H276.67V370h19.57v4.28h-29.4V318.48Z"
});

var _ref30 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "296.44 658.08 0 658.08 0 164.6 296.44 -0.14 296.44 46.11 38.4 189.18 38.4 620.02 296.44 620.02 296.44 658.08"
});

function SvgFthathLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 696",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFthathLogo);
export default __webpack_public_path__ + "static/media/fthath-logo.a3d7dde0.svg";
export { ForwardRef as ReactComponent };